import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';
import { Users } from 'react-feather';

function Mutasi() {

  //Roles
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataMutasi, setDataMutasi] = useState([]);
  const [saldo, setSaldo] = useState(0);


  // CONTROLLER & LOAD DATA
  const fetchDataMutasi = async (id) => {
    await baseAPI
      .get(`/v1/mutasitabung/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.mutasi;
        const totalSaldo = res.data.data.saldo;
        setSaldo(totalSaldo);
        setDataMutasi(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  useEffect(() => {
    setIsLoading(true);
    // if (users.role === ANGGOTA) {
      fetchDataMutasi(users.id);
    // }
  }, [token]);

  
  const mutasiListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Tanggal',
        id: 'tanggal',
        width: '5%',
        accessor: 'tanggal',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.trxsetortabung).format("DD-MM-yyyy")}</div>
      },
      {
        Header: 'Debit',
        id: 'debit',
        width: '12%',
        accessor: 'debit',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>Rp.{parseFloat(cellInfo.row.original.debit).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Kredit',
        id: 'kredit',
        width: '12%',
        accessor: 'kredit',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>Rp.{parseFloat(cellInfo.row.original.kredit).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Setoran Ke',
        id: 'setoranke',
        width: '8%',
        accessor: 'setoranke',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.setoran_ke}</div>
      },
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Mutasi Tabungan"
                columns={columns}
                data={dataMutasi}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Tabungan</Link> /{' '}
                <Link to='/tabungan/mutasi' style={{ color: '#333' }}>Mutasi</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download report data')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Report</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  )

    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      <div>
        <p>Saldo Tabungan: Rp.{parseFloat(saldo).toLocaleString('id-ID')}</p>
      </div>
      {isLoading ? <LoadingView /> : mutasiListView()}

    </div>

  );

}

export default Mutasi;